import { useMemo } from "react";
import type { Options } from "react-select";

import type { GroupedOptionsType } from "../../common-ui/form-fields/Dropdown";
import { useAccount } from "../../services/settings/hooks/useAccount";
import {
  addFavouritesToOptions,
  addRecentToOptions,
} from "../utils/DropdownUtils";
import {
  type DropdownOption,
  getVehicleTypeOptionValue,
} from "../utils/optionTransformers";
import type { VehicleType } from "./fragments/gql/VehicleType";
import { useRecentVehicleTypeCodes } from "./useRecentBookings";
import { useVehicleTypesForCustomerAndRouteAsOptions } from "./useVehicleTypesForCustomerAndRouteAsOptions";

export const useVehicleTypesForCustomerAndRouteAsOptionsWithFavoriteOptions = (
  customerNo: number | null,
  routeCode: string | null,
  skip: boolean = false,
) => {
  const { accountSettings } = useAccount();
  const recentVehicleTypeCodes = useRecentVehicleTypeCodes();
  const [options] = useVehicleTypesForCustomerAndRouteAsOptions(
    customerNo,
    routeCode,
    skip,
  );
  return useMemo(() => {
    let result:
      | GroupedOptionsType<DropdownOption<VehicleType>>
      | Options<DropdownOption<VehicleType>> = options;

    if (
      accountSettings.favouriteVehicleTypes &&
      accountSettings.favouriteVehicleTypes.length > 0
    ) {
      result = addFavouritesToOptions(
        result,
        accountSettings.favouriteVehicleTypes.map((v) =>
          getVehicleTypeOptionValue(v),
        ),
      );
    }

    if (recentVehicleTypeCodes.length > 0) {
      result = addRecentToOptions(result, recentVehicleTypeCodes);
    }

    return result;
  }, [options, accountSettings.favouriteVehicleTypes, recentVehicleTypeCodes]);
};
